<template>
  <div class="footer">
    <div class="bg-grey-lighten-4 d-flex flex-column">
      <div class="subscribe py-10" style="text-align: center">
        <h3 class="text-sub" style="font-weight: 800; font-size: 30px">
          subscribe to our newsletter
        </h3>
        <p class="mb-5 pragh-sub" style="color: grey; margin-top: 4px">
          get the latest updata on new products and upcoming sales
        </p>
        <div width="60%">
          <input
            class="input-sub"
            style="
              background-color: white;
              padding: 10px 20px;
              width: 400px;
              border-radius: 20px;
              outline: none;
            "
            type="text"
            placeholder="enter your email address"
          />
          <button
            class="btn-sub"
            style="
              margin-left: 2px;
              padding: 7px 10px;
              background-color: #2196f3;
              width: 100px;
              outline: none;
              cursor: pointer;
              border-radius: 20px;
              color: white;
            "
          >
            submit
          </button>
        </div>
      </div>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card elevation="0" color="#f5f5f5" class="card-footer">
              <v-card-title
                class="color-text"
                style="font-size: 18px; font-weight: 900"
                >SHOP</v-card-title
              >
              <v-card-text class="pt-0 pb-2">Electronics</v-card-text>
              <v-card-text class="pt-0 pb-3">Computers & Labs</v-card-text>
              <v-card-text class="pt-0 pb-3">Smartphones & Tablets</v-card-text>
              <v-card-text class="pt-0 pb-3">Cameras</v-card-text>
              <v-card-text class="pt-0 pb-3">Video Games & Systems</v-card-text>
              <v-card-text class="pt-0 pb-3">Home Furniture</v-card-text>
              <v-card-text class="pt-0 pb-3">Weekly Special</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card color="#f5f5f5" elevation="0" class="card-footer">
              <v-card-title
                class="color-text"
                style="font-size: 18px; font-weight: 900"
                >farther info</v-card-title
              >
              <v-card-text class="pt-0 pb-2">Customer Service </v-card-text>
              <v-card-text class="pt-0 pb-3">Reward Program </v-card-text>
              <v-card-text class="pt-0 pb-3">Shipping & Returns </v-card-text>
              <v-card-text class="pt-0 pb-3">Privacy Policy </v-card-text>
              <v-card-text class="pt-0 pb-3">Terms & Conditions </v-card-text>
              <v-card-text class="pt-0 pb-3">Blog</v-card-text>
              <v-card-text class="pt-0 pb-3">days Special</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card color="#f5f5f5" elevation="0" class="card-footer">
              <v-card-title
                class="color-text"
                style="font-size: 18px; font-weight: 900"
                >customer service</v-card-title
              >
              <v-card-text class="pt-0 pb-2">Search Terms </v-card-text>
              <v-card-text class="pt-0 pb-3">Advanced Search </v-card-text>
              <v-card-text class="pt-0 pb-3">Orders And Returns </v-card-text>
              <v-card-text class="pt-0 pb-3">Contact us </v-card-text>
              <v-card-text class="pt-0 pb-3">Consultant </v-card-text>
              <v-card-text class="pt-0 pb-3">Store Locations </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card color="#f5f5f5" elevation="0" class="card-footer">
              <v-card-title
                style="font-size: 14px; font-weight: 900; text-align: center"
              >
                <h4 class="logo-text">hot spot <span>+</span></h4>
              </v-card-title>
              <v-card-text class="pt-0 pb-2">
                <div class="d-flex justify-center align-center">
                  <v-icon>mdi-map-marker-radius</v-icon>
                  <div class="text ml-2 text-center">
                    <span class="d-block">656 Makram Street</span>
                    <span class="d-block">San Francisco, CA 96757, US</span>
                  </div>
                </div>
              </v-card-text>
              <v-card-text class="pt-0 pb-3">
                <div
                  class="d-flex justify-center align-center"
                  style="gap: 15px"
                >
                  <v-icon>mdi-phone</v-icon>
                  <span>Call us at (1234) 666-5446</span>
                </div>
              </v-card-text>
              <v-card-text class="pt-0 pb-3">
                <div
                  class="d-flex justify-center align-center"
                  style="gap: 15px"
                >
                  <v-icon>mdi-email</v-icon>
                  <span>example@domain.com</span>
                </div>
              </v-card-text>
              <v-card-text class="pt-0 pb-3">
                <div
                  class="d-flex justify-center align-center"
                  style="gap: 15px"
                >
                  <v-icon>mdi-facebook</v-icon>
                  <v-icon>mdi-whatsapp</v-icon>
                  <v-icon>mdi-linkedin</v-icon>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" class="text-center mb-8 mt-5">
            <img
              class="imge-footer-two"
              src="https://new-ella-demo.myshopify.com/cdn/shop/files/trust_551fa8e0-5f24-4fbc-bf22-74c01b859a01.png?v=1639984732"
              alt=""
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col
            cols="12"
            class="footer-col d-flex justify-space-between align-center mt-7"
          >
            <div class="end-footer">
              <p style="font-weight: 600" class="pargh-footer">
                <span
                  style="
                    color: #2196f3;
                    font-size: 20px;
                    font-weight: 700;
                    margin-right: 5px;
                  "
                  >©</span
                >
                <span style="color: #2196f3; font-size: 19px; font-weight: 800"
                  >2025</span
                >
                Ella Demo. All Rights Reserved. Powered By Shopify.
              </p>
              <span style="color: grey" class="d-block text-shop"
                >Shopify Themes By Halothem.es.net</span
              >
            </div>
            <img
              class="imge-footer"
              src="https://new-ella-demo.myshopify.com/cdn/shop/files/trust_551fa8e0-5f24-4fbc-bf22-74c01b859a01.png?v=1639984732"
              alt=""
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<style lang="css">
.footer .logo-text {
  font-size: 20px;
  font-weight: 800;
  background: linear-gradient(65deg, #3d5f7c, #5c825c, #ab3e3e);
  background-clip: text;
  color: transparent;
  text-transform: uppercase;
}
@media (max-width: 480px) {
  .footer .card-footer {
    text-align: center;
  }

  .footer .imge-footer-two {
    width: 89%;
  }
  .footer .text-sub {
    font-size: 19px !important;
    font-weight: 900 !important;
    padding: 0 12px !important;
  }
  .footer .pragh-sub {
    font-size: 13px;
  }
  .footer .input-sub {
    width: 253px !important;
    display: block !important;
    margin: auto !important;
  }
  .footer .btn-sub {
    margin-top: 12px;
  }
}
@media (min-width: 480px) and (max-width: 767px) {
  .footer .imge-footer-two {
    width: 90%;
  }
  .footer .card-footer {
    text-align: center;
  }
}
@media (max-width: 480px) {
  .footer .end-footer {
  }
  .footer .end-footer .text-shop {
    font-size: 12px;
  }
  .footer .end-footer .pargh-footer {
    font-size: 14px;
  }
  .footer .end-footer .pargh-footer span {
    font-size: 15px !important;
  }
  .footer .imge-footer {
    width: 91%;
    margin-top: 10px;
  }
  .footer .footer-col {
    flex-direction: column;
  }
}
@media (min-width: 480px) and (max-width: 767px) {
  .footer .imge-footer {
    margin-top: 22px;
    width: 90%;
  }
  .footer .footer-col {
    flex-direction: column;
  }
}
</style>
